import "core-js/stable";
import "regenerator-runtime/runtime";
import './common/styles/angular-busy.css'
import './common/styles/animate.min.css'
import './common/styles/generate-chart-styles.scss'
import './common/styles/bootstrap.css'
import './common/styles/bootstrapValidator.css'
import './common/styles/datepicker.css'
import './common/styles/font-awesome.css'
import './common/styles/ivh-treeview-theme-basic.css'
import './common/styles/ivh-treeview.css'
import './common/styles/jquery-ui-1.10.0.custom.scss'
import './common/styles/jquery.multiselect.css'
import "bootstrap-table";
import 'bootstrap-table/dist/bootstrap-table.css';
import "./filer/bootstrap-table-mobile.js";
import "./filer/bootstrap-table-sticky-header.js"
import "./filer/bootstrap-table-sticky-header.css"
import "./filer/bootstrap-table-jumpto.css"
import "./filer/bootstrap-table-jumpto.js"

import './common/styles/ngdialog.css'
import './common/styles/angular-tour.css'
//import './common/styles/nv.d3.css'
import './common/styles/overrides.css'
import './common/styles/pagination.css'
import './common/styles/select.css'
import './common/styles/select2.css'
import './common/styles/tb.css'
import './common/styles/toastr.css'
//import './common/styles/ui.jqgrid.css'
import './common/styles/styles.scss'
import './common/styles/backtester_tab.css'
import './common/styles/media.scss'

import './common/third_party/bootstrap.js'
import './common/styles/jquery.mCustomScrollbar.min.scss'

import './common/third_party/custom.js'
//import './common/third_party/d3.v3.min.js'
import './common/third_party/jquery.ddslick.js'
//import './common/third_party/jquery.jqgrid.min.js'
import './common/third_party/jquery.multiselect.min.js'
import './common/styles/colorbox.scss'
import './common/styles/whalewisdom_styles.scss'

//import 'free-jqgrid'
window.numbro=require('numbro');
//import 'jaaulde-cookies';
//import './common/third_party/nv.d3.js'
import './common/third_party/unslider.js'

window.Cookies=require('js-cookie')


import './common/app/layout.js'
import './common/app/login.js'
import './common/app/search.js'
import './common/app/statistics.js'
import './common/app/utilities.js'
import './common/app/whaleindex.js'
import './common/app/whalewisdom-tree.js'
import './common/app/drip-integration.js'

import './common/app/contact.js';
import './common/app/slack.js';
import './common/app/filer_stock_history.js';
import './common/app/tablepagination.min.js';
import './common/app/short_positions.js'
import './common/app/filing.js'
import './common/app/subscription2.js';
import './common/app/validation/bootstrapValidator.js';
import './common/app/validation/bootstrap.js';

import './common/app/heat_map3.js';
import './common/app/schedule13d.js';
import './common/app/jquery.colorbox-min.js';
import './common/app/ownership.js';
import './common/app/holdings_search.js';
import './common/app/stock_lookup.js';
import './common/app/etfs.js';

import './common/app/jquery.Storage.js';
import './common/app/statistic_charts.js';
import './common/app/refile.js';
import './common/app/hf_letter.js';
import './common/app/sector.js';